/**
 * Sets footer URL Targets on the menu.
 */
export const setFooterUrlTargets = (): void => {
  const footerElement: HTMLElement = document.querySelector('footer');

  // Handle no footer edge case
  if (!footerElement) return;

  // Locate footer links.
  const footerLinks: HTMLAnchorElement[] = Array.from(
    footerElement.querySelectorAll('a')
  );

  // Apply new target attributes where required.
  footerLinks.forEach((link) => {
    if (link.hostname !== window.location.hostname) {
      link.setAttribute('target', '_blank');
      link.setAttribute('rel', 'noopener noreferrer');
    }
  });
};
